import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { SendPostRequest } from "../http";
import Spinner from "./Spinner";
import { useSelector } from "react-redux";
import { formatDate } from "../Helper/Helper";

export default function NewsDetail() {
  const { id } = useParams();
  const { slug } = useParams();
  const [servicesDetail, setServicesDetail] = useState({});
  const [servicesList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(true);

  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesDetail();
  }, [slug]);

  const getServicesDetail = async () => {
    try {
      setLoading(true);
      const response = await SendPostRequest("news/detail", {
        slug: slug,
        // slug: slug,
      });

      if (response.status === "success") {
        setServicesList(response.data.lists);
        setServicesDetail(response.data.detail);
      } else {
        console.warn("No service detail found in the response.");
      }
    } catch (error) {
      console.error("Error fetching services detail:", error);
    } finally {
      setLoading(false);
    }
  };

  const [backgroundImage, setBackgroundImage] = useState("");
  useEffect(() => {
    let themeColor;
    if (sitedata) {
      themeColor = sitedata?.theme_color?.split(".css").join("");
    } else {
    }

    setBackgroundImage(`/assets/img/doctors/banner_bg_${themeColor}.svg`);
  }, [sitedata?.theme_color]);

  return (
    <>
      <Header />
      <section
        className="cs_banner cs_style_5 cs_bg_filed"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="container">
          <div className="">
            <h2 className="cs_banner_title cs_fs_65">
              {servicesDetail?.title}
            </h2>
          </div>
        </div>
      </section>
      <div className="container">
        <ol className="breadcrumb"></ol>
        <div className="cs_height_35"></div>
        <div className="cs_height_20"></div>
        <div className="row">
          <div className="col--lg-8 col-md-8 col-12 mobile_view_blogs">
            {loading ? (
              <div className="d-flex align-items-center justify-content-center">
                <Spinner />
              </div>
            ) : (
              <>
                <img
                  src={servicesDetail?.image_url}
                  alt="Blog Details"
                  className=" cs_radius_20 services-detail-img mb-4"
                />
                <h2 className="cs_post_title cs_semibold cs_fs_32">
                  {servicesDetail?.title}
                </h2>

                <div class="cs_post_meta author_detail_heading-wrapper mb-3">
                  <h3>Publish Date</h3>
                  <div class="cs_posted_by">
                    {formatDate(servicesDetail?.date)}
                  </div>
                </div>
                <div className="cs_blog_details">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: servicesDetail?.content,
                    }}
                  />
                </div>
                <div className="cs_height_92"></div>
              </>
            )}
          </div>
          <div className="col-lg-4 col-md-4 d-none d-lg-block">
            <div className="cs_sidebar">
              <div className="cs_sidebar_item service-detail-list">
                <h2 className="cs_sidebar_widget_title">Other News</h2>
                {loading ? (
                  <div className="d-flex align-items-center justify-content-center">
                    <Spinner />
                  </div>
                ) : servicesList?.length > 0 ? (
                  <ul>
                    {servicesList?.map((list, index) => (
                      <li key={index}>
                        <img src={list?.image} alt="Service" />
                        <Link
                          // to={`/service/${list?.uid}/${list?.service_title
                          //   .replaceAll(" ", "-")
                          //   .replaceAll("/", "-")}`}
                          to={`/news/detail/${list?.slug}`}
                        >
                          <div>
                            {list?.title}
                            {list?.date && (
                              <div className="blogdetail_sidebar_date mb-4 align-item-center">
                                <p>Publish Date:</p>
                                <p className="m-0">{formatDate(list?.date)}</p>
                              </div>
                            )}
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No other news found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_height_42 cs_height_xl_25"></div>
      <Footer />
    </>
  );
}
